// chatSocket.js — singleton WebSocket helper for the internal chat.
// Auto-reconnect with backoff. Exposes a tiny pub/sub API.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
// ws:// or wss:// derived from REACT_APP_BACKEND_URL
const WS_URL = BACKEND_URL.replace(/^http/, "ws") + "/api/chat/ws";

let socket = null;
let listeners = new Set();
let backoff = 1000;
let token = null;
let reconnectTimer = null;
let connected = false;

function emitStatus(s) {
    listeners.forEach((cb) => {
        try { cb({ type: "status", status: s }); } catch (e) { /* swallow */ }
    });
}

function _open() {
    if (!token) return;
    try {
        socket = new WebSocket(`${WS_URL}?token=${encodeURIComponent(token)}`);
    } catch (e) {
        scheduleReconnect();
        return;
    }
    socket.addEventListener("open", () => {
        connected = true;
        backoff = 1000;
        emitStatus("open");
    });
    socket.addEventListener("message", (ev) => {
        try {
            const msg = JSON.parse(ev.data);
            listeners.forEach((cb) => {
                try { cb(msg); } catch (e) { /* swallow */ }
            });
        } catch (e) { /* swallow */ }
    });
    socket.addEventListener("close", () => {
        connected = false;
        emitStatus("closed");
        scheduleReconnect();
    });
    socket.addEventListener("error", () => {
        try { socket.close(); } catch (e) { /* swallow */ }
    });
}

function scheduleReconnect() {
    if (!token) return;
    if (reconnectTimer) return;
    reconnectTimer = setTimeout(() => {
        reconnectTimer = null;
        backoff = Math.min(backoff * 2, 15000);
        _open();
    }, backoff);
}

export function connectChat() {
    token = localStorage.getItem("gtw_token");
    if (!token) return;
    if (socket && (socket.readyState === 0 || socket.readyState === 1)) return;
    _open();
}

export function disconnectChat() {
    token = null;
    if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null; }
    if (socket) {
        try { socket.close(); } catch (e) { /* swallow */ }
        socket = null;
    }
    connected = false;
}

export function isConnected() {
    return connected;
}

export function onChatEvent(handler) {
    listeners.add(handler);
    return () => listeners.delete(handler);
}
